import { isAxiosError } from "axios";

/**
 * The reason the server gave, when it gave one.
 *
 * Several endpoints refuse for stated, actionable reasons — "approve this
 * transfer before reconciling it", "no se puede retener comisión de los
 * honorarios de un escribano" — and that sentence is the only useful part of
 * the response. Collapsing it into a generic failure toast throws away the one
 * thing that tells the operator what to do next.
 *
 * Returns null when there is nothing usable, so the caller keeps its own
 * translated fallback:
 *
 *   toast.error(serverMessage(error) ?? t("...Failed"))
 *
 * Deliberately narrow: it reads `response.data.message` and nothing else. A
 * helper that also guessed at arrays, `error`, `detail` and bare strings would
 * eventually surface a stack trace or a validation array to a user.
 */
export function serverMessage(error: unknown): string | null {
  if (!isAxiosError(error)) return null;
  const message = (error.response?.data as { message?: unknown } | undefined)?.message;
  return typeof message === "string" && message.trim() ? message : null;
}
